import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "dialog-footer" }

import { ref, reactive,onMounted } from 'vue';
import {getAppTeamInviteLink,} from "@/request/team";
import {ElMessage, FormInstance} from "element-plus";
import useDialog from "@/hooks/useDialog";
import {copyText} from "@/utils/index";


export default /*@__PURE__*/_defineComponent({
  __name: 'InviteMember',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: __emit }) {

const formRef = ref<FormInstance>()

const emits = __emit

const {title,id,isShow,form,openDialog,closeDialog} =useDialog({
  initFormParam:{
  },
  getDetailsApi:getAppTeamInviteLink,
  addTitle:'邀请成员',
  editTitle:'邀请成员',
  afterOpenDialog:(_,row)=>{
    fetchAppTeamInviteLink(row);
  }
})

// 提交
const submit = async () => {
  // inviteLink.value='';
  closeDialog();
}

const inviteLink=ref();
const fetchAppTeamInviteLink=async(data)=>{
  const res=await getAppTeamInviteLink(data);
  inviteLink.value=res?.data?.data;
}

__expose({
  openDialog,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_unref(isShow))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_dialog, {
          width: "30vw",
          "model-value": true,
          center: "",
          "destroy-on-close": "",
          title: _unref(title),
          onClose: _unref(closeDialog)
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: submit
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("确定")
                ])),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              "label-position": "top",
              ref_key: "formRef",
              ref: formRef,
              model: _unref(form),
              "label-width": "90px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_space, { fill: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "通过链接邀请",
                      style: {"margin-bottom":"0"}
                    }, {
                      default: _withCtx(() => [
                        _cache[3] || (_cache[3] = _createTextVNode(" 邀请外部人员加入团队后，成为  ")),
                        _createVNode(_component_el_input, {
                          disabled: "",
                          style: {"width":"6vw"},
                          modelValue: _unref(form).name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).name) = $event)),
                          placeholder: "团队成员"
                        }, null, 8, ["modelValue"]),
                        _cache[4] || (_cache[4] = _createTextVNode("   ")),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(copyText)(inviteLink.value)))
                        }, {
                          default: _withCtx(() => _cache[2] || (_cache[2] = [
                            _createTextVNode(" 复制链接 ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _cache[5] || (_cache[5] = _createElementVNode("p", { style: {"margin-top":"0","color":"#8D9095"} }, [
                      _createTextVNode("链接有效期: "),
                      _createElementVNode("span", { style: {"color":"#2878FF"} }, "14 天")
                    ], -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["title", "onClose"])
      ]))
    : _createCommentVNode("", true)
}
}

})